import React, {useState, useEffect} from "react";
import { graphql } from "gatsby";
import { Col, Container, Row } from "react-bootstrap";
import classNames from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import ExtractRichText from "../../molecules/ExtractRichText";
import CustomReactCountup from "../../atoms/CustomReactCountup";
import "./paraInfographHeader.scss";

export const ParagraphInfographicHeaderLP = ({ node, tabData }) => {
  const [visited, setVisited] = useState(tabData === undefined) // set default as true if no tabs

  useEffect(() => {
    if(!visited && (Number(tabData?.current) === Number(tabData?.selected))){
      setVisited(true)
    }
  }, [tabData?.selected])

  const {
    field_figure,
    field_unit,
    relationships = {},
    field_type,
    field_body_text,
    field_figure_title,
    field_figure_body_text = {},
    field_map_title,
  } = node;

  const firstBlock = classNames("infograph__first-block", "row-gap-4", {
    "bg-idp-purple text-white": field_type == "idp_purple",
    "bg-idp-light-disaster text-white": field_type == "disaster",
    "bg-idp-light-conflict text-white": field_type == "conflict",
  });

  const secondBlock = classNames("infograph__second-block", "row-gap-4", {
    "bg-idp-light-purple text-white": field_type == "idp_purple",
    "bg-idp-disaster text-white": field_type == "disaster",
    "bg-idp-conflict text-white": field_type == "conflict",
  });

  return (
    <div>
      <Container className="general-container infograph">

        <Row className={firstBlock}>
          <Col xs={12} md={7} lg={6}>
            <div className="stat-wrapper">
              <div className="stat-count-up" data-value={`${Number(field_figure)}${field_unit || ''}`}>
                {(field_figure && visited) && (
                  <CustomReactCountup
                    className="infograph__big-figure"
                    end={field_figure}
                    suffix={field_unit}
                    redraw={!visited}
                  />
                )}
              </div>

              {relationships?.field_counter_icon?.relationships?.field_media_image
                ?.publicUrl && (
                <div className="infograph__icon-img_container">
                  <img
                    // removed svg field here and graphQL query as well.
                    className="infograph__icon-img"
                    alt={"Infograph Icon"}
                    src={
                      relationships?.field_counter_icon?.relationships
                        ?.field_media_image?.publicUrl
                    }
                  />
                </div>
              )}
            </div>
          </Col>

          <Col  xs={12} md={5} lg={6} >
            {field_map_title && (
              <h4 className="infograph__subheading">{field_map_title}</h4>
            )}

            {field_figure_body_text && (
              <ExtractRichText richText={field_figure_body_text?.value} />
            )}
          </Col>
        </Row>


        <Row className={secondBlock}>
          <Col xs={12} md={7} lg={6} className="text-center first-col">
            <GatsbyImage
              image={
                relationships?.field_card_image?.relationships
                  ?.field_media_image?.gatsbyImage
              }
            />
          </Col>
          <Col xs={12} md={5} lg={6}>
            {field_figure_title && (
              <h4 className="infograph__subheading">{field_figure_title}</h4>
            )}
            {field_body_text && (
              <ExtractRichText richText={field_body_text?.value} />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphInfographicHeaderLP on paragraph__infographic_header_lp {
    field_body_text {
      value
    }
    field_figure
    field_figure_body_text {
      value
    }
    field_figure_title
    field_map_title
    field_type
    field_unit
    relationships {
      field_card_image {
        relationships {
          field_media_image {
            gatsbyImage(width: 1500, quality: 100, placeholder: BLURRED)
            publicUrl
          }
        }
      }
      field_counter_icon {
        relationships {
          field_media_image {
            publicUrl
            width
            height
          }
        }
      }
    }
  }
`;
